import styled from 'styled-components';
import {
  AMZ_BASIL,
  AMZ_BLACK,
  AMZ_INFO_BG,
  AMZ_INFO_TXT,
  AMZ_SUCCESS,
  PRIMARY_100,
  PRIMARY_500,
} from '../../styles/colors';
import { IconFont } from '../../styles/font';
import { isAmazonHost } from '../../utils';

export type IconType = '\\e913' | '\\eaa3' | '\\e9d9';
export type NotificationVariant = 'success' | 'info';

export const ICON_TYPES = {
  SUCCESS: '\\e913' as IconType,
  INFO: '\\eaa3' as IconType,
  WARNING: '\\e9d9' as IconType,
} as const;

const ICON_STYLES = `
  ${IconFont}
  font-family: 'rs-iconfont';
  font-size: 18px;
  font-style: normal;
`;

export const Icon = styled.i<{ type: IconType | string }>`
  &&& {
    display: flex;
    align-items: center;
    :before {
      content: '${({ type }) => type}';
      color: inherit;
      ${ICON_STYLES}
    }
  }
`;

export const StyledNotificationBox = styled.div<{
  variant: NotificationVariant;
}>`
  &&& {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    border-radius: 4px;
    padding: 10px;
    font-size: ${isAmazonHost() ? '12px' : '14px'} !important;
    line-height: ${isAmazonHost() ? '16px' : '24px'} !important;
    font-weight: ${isAmazonHost() ? '400' : '300'};
    color: ${AMZ_BLACK};

    ${({ variant }) =>
      variant === 'success' &&
      `
      background-color: ${AMZ_BASIL};
      color: ${AMZ_SUCCESS};
      border: 1px solid ${AMZ_SUCCESS};
    `}

    ${({ variant }) =>
      variant === 'info' &&
      `
      background-color: ${isAmazonHost() ? AMZ_INFO_BG : PRIMARY_100};
      color: ${isAmazonHost() ? AMZ_INFO_TXT : PRIMARY_500};
      border: 1px solid ${isAmazonHost() ? AMZ_INFO_TXT : PRIMARY_100};
    `}
  }
`;

export const Text = styled.span<{ color?: string }>`
  &&& {
    color: ${({ color }) => color || 'inherit'};
  }
`;
